/* 🤖 this file was generated by svg-to-ts */
export const svgCircleBan: {
    name: "circle-ban";
    data: string;
} = {
    name: "circle-ban",
    data: '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 40 40"><path id="ng__circle-ban" fill="#e2d8ce" fill-rule="evenodd" d="M38 20C38 29.9411 29.9411 38 20 38C15.6442 38 11.6498 36.4528 8.53626 33.878L33.4178 8.00127C36.2673 11.1857 38 15.3905 38 20ZM7.06749 32.52L32.0035 6.58653C28.8186 3.7344 24.6118 2 20 2C10.0589 2 2 10.0589 2 20C2 24.8657 3.93057 29.2804 7.06749 32.52ZM40 20C40 31.0457 31.0457 40 20 40C8.9543 40 0 31.0457 0 20C0 8.9543 8.9543 0 20 0C31.0457 0 40 8.9543 40 20Z" clip-rule="evenodd"/></svg>',
};
